module.exports = __webpack_public_path__ + "static/media/22.ca7ce251.gif";